import { Dimmer } from "@/components/spinner";
import useTable from "@/components/useTable";
import { formatMoneda, formatoMonto } from "@/util/varios";
import axios from "axios";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

export default function ModalComresis(props) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const headCells = [
    {
      id: 0,
      label: "Estado",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 1,
      label: "Periodo",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 2,
      label: "Monto",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const buscarDetallado = ({ rif }) => {
    setLoading(true);
    axios
      .get(
        `https://comresis.opensiap.com.ve/api/api/opensiap/deuda_pendiente?rif=${rif}`,
        {
          headers: {
            "X-AdminSecret": "6d8b99e73a4d7e99c2a4c66697c5cf08",
          },
        },
      )
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data);
        } else {
          setRecords([]);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const salir = () => {
    props.onShow();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      onShow={() => {
        if (props.rif) {
          buscarDetallado({ rif: props.rif });
        }
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">Detallado de Comresis</h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between row col-md-12 p-0 m-0">
          <div className="card border-0 shadow-sm col-12">
            <div className="card-body px-4">
              <div className="d-flex flex-column flex-md-row align-items-center gap-4">
                <div className="flex-shrink-0">
                  <div className="bg-primary bg-opacity-10 p-3 rounded-3">
                    <img
                      src="https://comresis.pagosweb.com.ve/COMRESIS.png"
                      alt="Logo COMRESIS"
                      width={100}
                      height={100}
                      className="img-fluid"
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                </div>
                <div className="flex-grow-1 text-center text-md-start">
                  <p className="mb-0 text-muted">
                    La Compañía Municipal de Gestión y Recolección de Residuos
                    Sólidos e Infraestructura Sanitaria le recuerda que el
                    servicio del aseo es un deber formal.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 m-0 p-0">
            <div className="m-0 p-0 col-12">
              <TblContainer>
                <TblHead />
                <tbody>
                  {records &&
                    records.length > 0 &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <tr
                        key={index}
                        style={{
                          padding: "0",
                          cursor: "auto",
                        }}
                      >
                        <td
                          className="align-baseline"
                          style={{
                            fontSize: "11px",
                            textAlign: "center",
                            width: "auto",
                          }}
                        >
                          Por Pagar
                        </td>
                        <td
                          className="align-baseline"
                          style={{
                            fontSize: "11px",
                            textAlign: "center",
                            width: "auto",
                          }}
                        >
                          {item.periodo || "N/A"}
                        </td>
                        <td
                          className="align-baseline"
                          style={{
                            fontSize: "11px",
                            textAlign: "center",
                            width: "auto",
                          }}
                        >
                          {item.monto
                            ? formatMoneda(
                                item.monto.toString().replace(".", ","),
                                ",",
                                ".",
                                2,
                              ) + "€"
                            : "0,00 €"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <Dimmer active={loading} inverted />
    </Modal>
  );
}
